export function formatPath(input) {
    return input.replace('/sport', '').replace(/\/$/, '');
}
export const SPORTS_SECTIONS = {
    '/': {
        slug: 'sport-all',
        title: 'Все виды',
    },
    '/football': {
        slug: 'sport-football',
        title: 'Футбол',
    },
    '/hockey': {
        slug: 'sport-hockey',
        title: 'Хоккей',
    },
    '/tennis': {
        slug: 'sport-tennis',
        title: 'Теннис',
    },
    '/box': {
        slug: 'sport-box',
        title: 'Бокс/MMA',
    },
    // '/biatlon': {
    //   slug: 'sport-biatlon',
    //   title: 'Биатлон',
    // },
    '/figure-skating': {
        slug: 'sport-figure-skating',
        title: 'Фигурное катание',
    },
    '/autosport': {
        slug: 'sport-autosport',
        title: 'Автоспорт',
    },
    '/other': {
        slug: 'sport-other',
        title: 'Другие виды',
    },
};
